import PropTypes from 'prop-types';
import { useMutation, useApolloClient } from '@apollo/client';
import { formatIsoDate, addDays } from '../../../Helpers/dateFormatter';
import ReplaceMealMutation from './ReplaceMealMutation';
import DailyDietPlanQuery from '../Fetch/DailyDietPlanQuery';
import MealDetailsQuery from '../FetchMeal/MealDetailsQuery';
import clearShoppingListCache from '../../ShoppingList/clearShoppingListCache';

const ReplaceMealConnectorApollo = ({ children, date, post }) => {
  const client = useApolloClient();

  const [replaceMeal, { data, loading, error }] = useMutation(ReplaceMealMutation);

  const createReplaceMeal = async ({ originalMealId, replacementId, userDietSetId, mealType }) => {
    const serializedState = client.cache.extract();

    const UserDailyDietMealItems = Object.values(serializedState).filter(
      (item) => item.__typename === 'UserDailyDietMeal'
    );

    const response = await replaceMeal({
      variables: {
        request: {
          date: formatIsoDate(date),
          originalMealId,
          replacementId,
        },
      },
      update: (cache) => {
        UserDailyDietMealItems.forEach((item) => {
          cache.evict({
            id: `UserDailyDietMeal:{"key":"${item.key}"}`,
            fieldName: 'replacements',
          });
        });
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: DailyDietPlanQuery,
          variables: {
            date: formatIsoDate(date),
            canBeCopiedToDate: formatIsoDate(addDays(date, 1)),
          },
        },
        {
          query: MealDetailsQuery,
          variables: {
            userDietSetId,
            mealType,
            dietMealId: replacementId,
          },
        },
      ],
    });

    client.cache.gc();

    clearShoppingListCache(client);

    // broadcast channel
    if (post) {
      post('back_and_reload');
    }

    return response;
  };

  return children({
    replaceMeal: {
      replace: createReplaceMeal,
      response: data,
      loading,
      error,
    },
  });
};

ReplaceMealConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  post: PropTypes.func,
};

export default ReplaceMealConnectorApollo;
